import { ICommand } from "yfiles";
import bindCommand from "./bindCommand";
export default (graphComponentRef, undoSelector, redoSelector) => {
    undoSelector && bindCommand(undoSelector, ICommand.UNDO, graphComponentRef.current, null);
    redoSelector && bindCommand(redoSelector, ICommand.REDO, graphComponentRef.current, null);
};
